import { inject, Injectable, signal, type Signal } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';

import { AbilitiesSelectors } from '@core/abilities-data';
import type { Ability } from '@core/abilities-types';

@Injectable({ providedIn: 'root' })
export class AbilityFacade {
  private store = inject(Store);

  public checkAbility$(ability: Ability): Observable<boolean> {
    return this.checkAbilities$(ability);
  }

  public checkAbility(ability: Ability): Signal<boolean> {
    return this.checkAbilities(ability);
  }

  public checkAbilities$(abilities: Ability | Ability[]): Observable<boolean> {
    if (!abilities) return of(false);

    return this.select('select', abilities);
  }

  public checkAbilities(abilities: Ability | Ability[]): Signal<boolean> {
    if (!abilities) return signal(false);

    return this.select('selectSignal', abilities);
  }

  private select<T extends 'select' | 'selectSignal'>(
    selectKind: T,
    abilities: Ability | Ability[],
  ) {
    const selector = Array.isArray(abilities)
      ? AbilitiesSelectors.hasMany(abilities)
      : AbilitiesSelectors.hasOne(abilities);
    return <T extends 'select' ? Observable<boolean> : Signal<boolean>>(
      (selectKind === 'select' ? this.store.select(selector) : this.store.selectSignal(selector))
    );
  }
}
